import { CARD_PROVIDER_ASSETS } from '@config/cards';

export enum CARD_PROVIDER_NAME {
  VISA = 'VISA',
  MASTERCARD = 'MC',
}

export enum ACTOR_CARD_PROVIDER_NAME {
  AMEX = 'AMEX',
  MASTERCARD = 'CA',
  DISCOVER = 'DISCOVER',
  VISA = 'VI',
  MAESTROINTL = 'MAESTROINTL',
}

export enum ACTOR_CARD_PROVIDER_NORMALIZED_NAME {
  AMEX = 'AMEX',
  CA = 'MASTERCARD',
  DISCOVER = 'DISCOVER',
  VI = 'VISA',
  MAESTROINTL = 'MAESTRO',
}

export type CardProviderInfo = {
  src: string | null;
  label: string;
};

export type SupportedCardBrand = keyof typeof CARD_PROVIDER_ASSETS;
